/**
 * @desc 查询物流订单详细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<ObjectMap>;
export function request(
  params: API.tms.transportMaster.tmsAndToDetail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/tmsAndToDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
